module.exports = __webpack_public_path__ + "img/ico_certifiate.df48347b.png";